import { render, staticRenderFns } from "./ColumnPostActions.vue?vue&type=template&id=6267b82c&"
import script from "./ColumnPostActions.vue?vue&type=script&lang=js&"
export * from "./ColumnPostActions.vue?vue&type=script&lang=js&"
import style0 from "./ColumnPostActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports